function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3.696094mm",
    height: "5.9148393mm",
    viewBox: "0 0 3.696094 5.9148393",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.088728,-96.577311)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 33.430916,101.4 q 0.171875,0.16016 0.382812,0.23828 0.210938,0.0742 0.480469,0.0742 0.722656,0 1.191406,-0.39844 0.472657,-0.40234 0.472657,-1.00781 0,-0.472655 -0.308594,-0.734373 -0.308594,-0.265625 -0.859375,-0.265625 -0.324219,0 -0.683594,0.07422 -0.359375,0.07031 -0.394531,0.07031 -0.109375,0 -0.164063,-0.05469 -0.05469,-0.05469 -0.05469,-0.164062 0,-0.05469 0.175781,-0.863281 0.175781,-0.8125 0.324219,-1.550782 0.308594,0.01953 0.546875,0.03125 0.238281,0.0078 0.441406,0.0078 0.578125,0 0.945313,-0.04297 0.367187,-0.04687 0.59375,-0.136719 0.05859,0.105469 0.08594,0.203125 0.03125,0.09375 0.03125,0.175782 0,0.25 -0.195312,0.34375 -0.191407,0.08984 -0.882813,0.08984 -0.253906,0 -0.527344,-0.0039 -0.273437,-0.0078 -0.570312,-0.01953 -0.03906,0.210937 -0.105469,0.550781 -0.06641,0.339844 -0.160156,0.785156 0.246094,-0.04687 0.433594,-0.06641 0.1875,-0.02344 0.328125,-0.02344 0.796875,0 1.261718,0.40625 0.464844,0.40625 0.464844,1.097658 0,0.38672 -0.140625,0.73437 -0.136719,0.34766 -0.394531,0.60938 -0.402344,0.41406 -0.914063,0.625 -0.511718,0.20703 -1.101562,0.20703 -0.445313,0 -0.695313,-0.12109 -0.25,-0.125 -0.25,-0.33985 0,-0.0977 0.05859,-0.23047 0.0625,-0.13281 0.183594,-0.30078 z",
    style: {
      fontSize: 8,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit5);
export default __webpack_public_path__ + "static/media/digit-5.b6e07919acaa338b0915d9dbcc1639d6.svg";
export { ForwardRef as ReactComponent };